
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Components": () => {
return Promise.all(/*  | __federation_expose_Components */ [__webpack_require__.e("3424"), __webpack_require__.e("9846"), __webpack_require__.e("3799"), __webpack_require__.e("5897"), __webpack_require__.e("820"), __webpack_require__.e("2559"), __webpack_require__.e("9540"), __webpack_require__.e("6361"), __webpack_require__.e("559"), __webpack_require__.e("5685"), __webpack_require__.e("549"), __webpack_require__.e("6314"), __webpack_require__.e("1080"), __webpack_require__.e("2670"), __webpack_require__.e("3597"), __webpack_require__.e("701"), __webpack_require__.e("3373")]).then(() => (() => (__webpack_require__(79362))));
},
"./Hooks": () => {
return __webpack_require__.e(/*  | __federation_expose_Hooks */ "3597").then(() => (() => (__webpack_require__(1970))));
},
"./Contexts": () => {
return __webpack_require__.e(/*  | __federation_expose_Contexts */ "4121").then(() => (() => (__webpack_require__(21354))));
},
"./Stores": () => {
return Promise.all(/*  | __federation_expose_Stores */ [__webpack_require__.e("2559"), __webpack_require__.e("6361"), __webpack_require__.e("2670"), __webpack_require__.e("5311")]).then(() => (() => (__webpack_require__(5472))));
},
"./ApplicationEvents": () => {
return __webpack_require__.e(/*  | __federation_expose_ApplicationEvents */ "6314").then(() => (() => (__webpack_require__(83391))));
},
"./Services": () => {
return Promise.all(/*  | __federation_expose_Services */ [__webpack_require__.e("559"), __webpack_require__.e("489")]).then(() => (() => (__webpack_require__(20178))));
},
"./Api": () => {
return __webpack_require__.e(/*  | __federation_expose_Api */ "5897").then(() => (() => (__webpack_require__(71056))));
},
"./Authentication": () => {
return Promise.all(/*  | __federation_expose_Authentication */ [__webpack_require__.e("8257"), __webpack_require__.e("6521"), __webpack_require__.e("3424"), __webpack_require__.e("8042"), __webpack_require__.e("9032"), __webpack_require__.e("3799"), __webpack_require__.e("5897"), __webpack_require__.e("820"), __webpack_require__.e("9626"), __webpack_require__.e("9965")]).then(() => (() => (__webpack_require__(85871))));
},
"./Utils": () => {
return __webpack_require__.e(/*  | __federation_expose_Utils */ "8508").then(() => (() => (__webpack_require__(2331))));
},
"./Icons": () => {
return Promise.all(/*  | __federation_expose_Icons */ [__webpack_require__.e("3799"), __webpack_require__.e("820"), __webpack_require__.e("5685"), __webpack_require__.e("549"), __webpack_require__.e("4047")]).then(() => (() => (__webpack_require__(58233))));
},
"./Images": () => {
return Promise.all(/*  | __federation_expose_Images */ [__webpack_require__.e("3799"), __webpack_require__.e("6915")]).then(() => (() => (__webpack_require__(19697))));
},
"./Dictionaries": () => {
return __webpack_require__.e(/*  | __federation_expose_Dictionaries */ "9641").then(() => (() => (__webpack_require__(7259))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };